import useInfrastructure from "hooks/useInfrastructure.hook";
import { useChatSelected } from "hooks/chat/useChatSelected.hook";

export function useChatAgentSelected(id) {
  const { repositories } = useInfrastructure();
  const repository = repositories.agents;

  return useChatSelected({
    id,
    repository
  });
}